import { gql } from '@apollo/client';
import { categoryFragment } from '../fragments/category';

export const getCategoriesQuery = gql`
    ${categoryFragment}

    query GetCategories {
        categories {
            ...CategoryFields
        }
    }
`;
